import authService from '../services/authService';

export function useLogout(): () => void {
  return () => {
    authService.logout();
    window.location.href = '/';
  };
}
